import { useContext } from 'react';
import { TopBarMenuButtonStateContext } from './top-bar-menu-button-state-context';

export function useTopBarMenuButtonStateHook() {
  return useContext(TopBarMenuButtonStateContext);
}
